var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 33",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.235 69.567"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 56",
    d: "M.012 69.568c-.344-10.667 6.8-24.837 19.181-30.836 9.523 7.381 21.273 7.419 30.835 0 12.906 6.255 19.549 20.783 19.194 30.836z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57",
    d: "M34.63 0a20.28 20.28 0 11-20.301 20.208A20.073 20.073 0 0134.63 0z"
  })));
}

export default __webpack_public_path__ + "3322d59a29c5395f22f56c6e25e420c7.svg";
export { SvgIconAvatar as ReactComponent };